import { get as getCookie } from 'js/lib/cookie';

import { type GraphQLGatewayLinks, graphqlGatewayLinkEndpoints } from './constants';
import graphqlGatewayQueryLinkOverrideMap from './graphqlGatewayQueryLinkOverrideMap';

/**
 * allows to set a specific link to use for queries by name.
 */
export const graphqlGatewayQueryLinkOverrideFactory =
  (overrides: Record<string, string | Record<string, string>> = graphqlGatewayQueryLinkOverrideMap) =>
  (operationName: string, clientName?: string, appName?: string): GraphQLGatewayLinks | string | null => {
    if (clientName && !(clientName in graphqlGatewayLinkEndpoints)) {
      return null;
    }

    const operationOverride = overrides[operationName];
    if (operationOverride) {
      if (typeof operationOverride === 'string') {
        return operationOverride;
      }

      if (appName && typeof operationOverride[appName] === 'string') {
        return operationOverride[appName];
      }
    }

    // E2E tests need the ability to override the query link for the gateway for now, until Assembler is turned off
    const cookieOverride = getCookie('X-Coursera-GraphQL-Query-Link-Override');
    if (cookieOverride) {
      return cookieOverride;
    }

    return null;
  };

export const graphqlGatewayQueryLinkOverride = graphqlGatewayQueryLinkOverrideFactory();
